module.exports = __webpack_public_path__ + "img/sf-logo.31420547.png";